import { create } from 'zustand';

export const useDetalleComercioStore = create((set, get) => ({
  detalles: {},

  guardarDetalle: (id, data) => {
    set((state) => ({
      detalles: {
        ...state.detalles,
        [id]: data,
      },
    }));
  },

  obtenerDetalle: (id) => {
    return get().detalles[id] || null;
  },

  limpiarDetalles: () => {
    set({ detalles: {} });
  },
}));